import { h, FunctionComponent } from "preact";
import { GalleryImage } from "../../gallery/gallery_image";
import { TileColor, TILE_COLORS, TILE_SIZES } from "./tile_styles";
import { Image } from "./image";

import css from "./tile.scss";
import { useCallback } from "preact/hooks";

export interface Tile {
  color: TileColor;
  size: "small" | "medium" | "large" | "x-large";
  position: "left" | "right" | "far-left" | "far-right";
  lift?: boolean;
  image: GalleryImage;
}

interface Props {
  tile: Tile;
  tileElementRef: (tile: Tile) => (el: HTMLDivElement | null) => void;
  onClick?: () => void;
  class?: string;
}

export const TileComponent: FunctionComponent<Props> = (props) => {
  const { tile, onClick, tileElementRef } = props;

  const handleTileClick = useCallback(() => {
    if (onClick) onClick();
  }, [onClick]);

  const image = tile.image;

  const tileSizeInfo = TILE_SIZES[tile.size]!;
  const tileColorInfo = TILE_COLORS[tile.color];

  const style = {
    width: `${tileSizeInfo.width}vw`,
    height: `${tileSizeInfo.width / image.aspect}vw`,
    backgroundColor: tileColorInfo.backgroundColor,
  };

  return (
    <div
      class={
        props.class +
        " " +
        css(`tile-pos-${tile.position}`, {
          "tile-pos-lift": !!tile.lift,
        })
      }
    >
      <div
        onClick={handleTileClick}
        ref={tileElementRef(tile)}
        class={css("tile")}
        style={style}
      >
        {image ? (
          <div class={css("image")}>
            <Image image={image} />
          </div>
        ) : (
          <div class={css("image-placeholder")}></div>
        )}
      </div>
    </div>
  );
};
